import { useState, useEffect } from 'react'

export const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [user, setUser] = useState(null)

    useEffect(() => {
        const token = localStorage.getItem('admin_token')
        const userData = localStorage.getItem('admin_user')

        if (token && userData) {
            try {
                const parsedUser = JSON.parse(userData)
                setUser(parsedUser)
                setIsAuthenticated(true)
            } catch (error) {
                console.error('Error parsing user data:', error)
                localStorage.removeItem('admin_token')
                localStorage.removeItem('admin_user')
            }
        }

        setIsLoading(false)
    }, [])

    const login = (token, userData) => {
        localStorage.setItem('admin_token', token)
        localStorage.setItem('admin_user', JSON.stringify(userData))
        setUser(userData)
        setIsAuthenticated(true)
    }

    const logout = () => {
        localStorage.removeItem('admin_token')
        localStorage.removeItem('admin_user')
        setUser(null)
        setIsAuthenticated(false)
    }

    return {
        isAuthenticated,
        isLoading,
        user,
        login,
        logout
    }
}
